<template>
  <!-- :close-on-click-modal="true" -->
  <!-- v-model="watch_data" -->
  <el-dialog
    :visible.sync="watch_data"
    :show-close="false"
    width="500px"
    top="0"
    class="projects-list-dialog"
    ref="AddRenameProjectAddUser"
    @close="close"
  >
    <template #title>
      <span
        class="el-dialog__title"
        v-html="$t('chat.linked_list.popup_title')"
      ></span>
    </template>
    <div class="projects-list-popup scroll-bar-2">
      <div class="projects-list-popup__group" v-if="standaloneLists.length">
        <h3>{{ $t("chat.linked_list.no_folder") }}</h3>
        <ul class="projects-list-popup__lists-wrapper">
          <li
            v-for="project in standaloneLists"
            :key="project._id"
          >
            <div
              @click="(e) => checkProject(project, e)"
              class="project-item"
              v-if="project._id != getUserData.shortcut_inbox"
              style="display: flex"
            >
              <ShortcutsIcon></ShortcutsIcon>
              <div
                class="project_name_body no_messages"
                :data-id="project._id"
                style="width: calc(100% - 33px)"
              >
                <div class="project_name" style="width: 100%">
                  <p>
                    {{ project.name }}
                  </p>
                  <!-- <p class="last_comment_in_project__user_name num_task">
                    {{ getNumberOfTasks[project._id] ? getNumberOfTasks[project._id] : 'No' }} tasks
                  </p> -->
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div
        class="projects-list-popup__group"
        v-for="folder in foldersWithLists"
        :key="folder._id"
      >
        <h3>{{ folder.name }}</h3>
        <ul class="projects-list-popup__lists-wrapper">
          <li v-for="project in folder.lists" :key="project._id">
            <div
              @click="(e) => checkProject(project, e)"
              class="project-item"
              style="display: flex"
            >
              <ShortcutsIcon></ShortcutsIcon>
              <div
                class="project_name_body no_messages"
                :data-id="project._id"
              >
                <div class="project_name">
                  <p>{{ project.name }}</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <button class="projects-list-popup__close" type="button" @click="close">
        {{ $t("app.alert.close") }}
      </button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ShortcutsIcon from "../projects/ShortcutsIcon.vue";

import { EventEmitter } from "../../main";

export default {
  props: {
    chat_id: [String],
    project_id: [String],
    chat_users: [Array],
  },
  data() {
    return {
      list_id: "",
      watch_data: false,
      isSubmitting: false,
      pendingRequest: null,
    };
  },
  computed: {
    ...mapGetters([
      "getProjects",
      "getChats",
      "getUserData",
      "getKnownUsers",
      "getUsersByProject",
      "getUsersByChat",
      "getLists",
      "getNumberOfTasks",
      "getSortedLists",
    ]),
    currentChatId() {
      return this.chat_id || this.$route.params.chat_id;
    },
    standaloneLists() {
      return (this.getSortedLists.lists || []).filter(
        (list) => list && list._id != this.getUserData.shortcut_inbox
      );
    },
    foldersWithLists() {
      return (this.getSortedLists.folders || [])
        .map((folder) => ({
          ...folder,
          lists: (folder.lists || []).filter(
            (list) => list && list._id != this.getUserData.shortcut_inbox
          ),
        }))
        .filter((folder) => folder.lists.length > 0);
    },
  },
  sockets: {
    OUT_AddListsChats(data) {
      if (!this.pendingRequest) return;
      if (!data || data.chat_id != this.pendingRequest.chat_id) return;

      this.list_id = data.list_id || "";
      this.clearPendingRequest();

      if (this.watch_data) {
        this.close();
      }

      EventEmitter.$emit("LinkListChatSuccess", data);
    },
    OUT_LinkListChat(data) {
      if (!this.pendingRequest || !data) return;

      if (data.chat_id && data.chat_id != this.pendingRequest.chat_id) return;
      if (
        data.list_id !== undefined &&
        data.list_id !== this.pendingRequest.list_id
      ) {
        return;
      }

      if (data.status == "failed") {
        this.openUsersFailedPlanPopup(data.usersFailedPlan || []);
        this.clearPendingRequest();
        return;
      }

      const hasAccess =
        data.hasAccess === false ||
        (data.data && data.data.hasAccess === false);

      if (hasAccess) {
        this.openErrorPopup(
          data.text || data.message || this.$t("list.add.error_server")
        );
        this.clearPendingRequest();
        return;
      }

      if (data.text) {
        this.openErrorPopup(data.text);
        this.clearPendingRequest();
      }
    },
    OUT_AlertMessage(data) {
      if (!this.pendingRequest) return;

      const actionKey = data && data.action_key ? data.action_key : "";
      if (actionKey && !actionKey.startsWith("IN_LinkListChat")) return;

      if (actionKey === "IN_LinkListChat:proceed") {
        this.setSubmitting(false);
        this.openConfirmPopup(data);
        return;
      }

      this.clearPendingRequest();
    },
    OUT_Message() {
      if (!this.pendingRequest || !this.isSubmitting) return;

      this.clearPendingRequest();
    },
    OUT_CheckUserPlan(data) {
      if (data.no_valid) {
        let users = "";

        data.no_valid.forEach((a) => {
          let user = this.getKnownUsers.filter((e) => e._id == a);
          users += `<li>${user[0].email}</li>`;
        });

        let data = {
          data: {
            text:
              this.$t("app.alert.no_valid") +
              `
              <ul>${users}</ul>
            `,
            cancel: this.$t("app.alert.cancel"),
            delete: "",
          },
        };

        EventEmitter.$emit("OpenPopup", data);
      }
    },
  },
  mounted() {
    // localStorage.setItem('project_id', this.project_id)
    this.list_id = this.project_id;
    EventEmitter.$on("openProjectsList", () => {
      this.watch_data = true;
    });
    EventEmitter.$on("requestLinkListChat", ({ list_id = "", chat_id } = {}) => {
      this.submitLinkRequest({
        list_id,
        chat_id: chat_id || this.currentChatId,
        approved: false,
      });
    });
  },
  methods: {
    close() {
      this.watch_data = false;
      EventEmitter.$emit("closeProjectLists", true);
    },
    setSubmitting(value) {
      this.isSubmitting = value;
      EventEmitter.$emit("LinkListChatSubmitting", {
        chat_id: this.currentChatId,
        value,
      });
    },
    clearPendingRequest() {
      this.pendingRequest = null;
      this.setSubmitting(false);
    },
    submitLinkRequest({ list_id = "", chat_id, approved = false }) {
      if (this.isSubmitting) return;

      this.pendingRequest = {
        list_id,
        chat_id,
      };
      this.list_id = list_id;
      this.setSubmitting(true);

      this.$socket.emit("IN_LinkListChat", {
        list_id,
        chat_id,
        approved,
      });
    },
    resendApprovedRequest() {
      if (!this.pendingRequest) return;

      this.setSubmitting(true);
      this.$socket.emit("IN_LinkListChat", {
        ...this.pendingRequest,
        approved: true,
      });
    },
    formatUsersList(usersFailedPlan) {
      const items = (usersFailedPlan || [])
        .map((user) => {
          if (user && typeof user === "object") {
            return user.email || user.name || user._id || "";
          }

          const knownUser = this.getKnownUsers.find(
            (item) => item._id == user || item.email == user
          );
          if (knownUser) {
            return knownUser.email || knownUser.name || knownUser._id;
          }

          return user;
        })
        .filter(Boolean)
        .map((user) => `<li>${user}</li>`)
        .join("");

      return items ? `<ul>${items}</ul>` : "";
    },
    openErrorPopup(text) {
      EventEmitter.$emit("OpenPopup", {
        type: "linkListChatError",
        data: {
          text,
          cancel: this.$t("app.alert.ok"),
          delete: "",
        },
      });
    },
    getButtonByType(buttons, type) {
      return (buttons || []).find((button) => button.type === type) || null;
    },
    mapPopupButtonClass(button) {
      if (!button) return "";
      if (button.style === "danger") return "red";
      if (button.style === "primary") return "blue";
      return "";
    },
    openConfirmPopup(payload) {
      const cancelButton = this.getButtonByType(payload.buttons, "cancel");
      const actionButton = this.getButtonByType(payload.buttons, "action");

      EventEmitter.$emit("OpenPopup", {
        type: "addNonMemberUsers",
        data: {
          text: payload.text,
          cancel: cancelButton ? cancelButton.label : this.$t("app.alert.cancel"),
          accept: actionButton
            ? actionButton.label
            : this.$t("app.alert.proceed"),
          class: {
            cancel: this.mapPopupButtonClass(cancelButton),
            accept: this.mapPopupButtonClass(actionButton),
          },
          action: this.resendApprovedRequest,
          onCancel: this.clearPendingRequest,
        },
      });
    },
    openUsersFailedPlanPopup(usersFailedPlan) {
      EventEmitter.$emit("OpenPopup", {
        type: "linkListChatFailed",
        data: {
          text:
            this.$t("app.alert.no_valid") +
            `
              ${this.formatUsersList(usersFailedPlan)}
            `,
          cancel: this.$t("app.alert.ok"),
          delete: "",
        },
      });
    },
    checkProject(project, e) {
      e.preventDefault();
      if (this.isSubmitting) return;

      const id = project._id;

      if (id == this.list_id) {
        return;
      } else {
        this.submitLinkRequest({
          list_id: id,
          chat_id: this.currentChatId,
          approved: false,
        });
      }
    },
  },
  watch: {
    project_id(newVal) {
      this.list_id = newVal;
    },
  },
  components: {
    ShortcutsIcon,
  },
};
</script>
